import { IconButton, styled as muiStyled } from '@mui/material'

export const TimerGridItemMenuButton = muiStyled(IconButton)(
  ({ theme }) => `
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    background: #fff;
    box-shadow: 0 0 10px -6px #000;
    &:hover {
        background: #f0f0f0;
    }
`,
)
